import endpoints from 'helper/endpoints'
import {fireErrorToast, fireSuccessToast, globalApiErrorHandler} from 'helper/functions'
import httpClient from 'helper/httpClient'
import React from 'react'
import {
  GET_UNIT_FAIL,
  GET_UNIT_LIST_FAIL,
  GET_UNIT_LIST_REQUEST,
  GET_UNIT_LIST_SUCCESS,
  GET_UNIT_REQUEST,
  GET_UNIT_SUCCESS,
} from 'redux/actionType'
import {Trans} from '@lingui/macro'

export const getUnitList = (limit = 1000, offset = 0, meta, search) => {
  return (dispatch) => {
    dispatch({type: GET_UNIT_LIST_REQUEST})
    const searchQuery = search ? `?search=${search}` : ''
    return httpClient
      .get(endpoints.units + searchQuery, {
        limit: limit,
        offset: offset,
        order_by:
          meta?.orderBy && meta?.orderDirection && `${meta?.orderBy}:${meta?.orderDirection}`,
      })
      .then((res) => {
        dispatch({type: GET_UNIT_LIST_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_UNIT_LIST_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const getUnit = (id) => {
  return (dispatch) => {
    dispatch({type: GET_UNIT_REQUEST})
    return httpClient
      .get(endpoints.units + '/' + id)
      .then((res) => {
        dispatch({type: GET_UNIT_SUCCESS, data: res.data})
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        dispatch({type: GET_UNIT_FAIL})
        return globalApiErrorHandler(err)
      })
  }
}

export const createUnit = (data) => {
  return (dispatch) => {
    return httpClient
      .post(endpoints.units, data)
      .then((res) => {
        fireSuccessToast(<Trans>New unit created.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}

export const patchUnit = (id, data) => {
  return (dispatch) => {
    return httpClient
      .patch(endpoints.units + '/' + id, data)
      .then((res) => {
        fireSuccessToast(<Trans>Unit updated.</Trans>)
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        if (err.response?.status === 422 && err.response?.data?.errors?.length) {
          return Promise.reject(err?.response?.data?.errors)
        } else {
          return globalApiErrorHandler(err)
        }
      })
  }
}
